"use client";

import { useRouter } from "next/navigation";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import RichText from "@/components/atoms/rich-text/rich-text";
import ActionButton from "@/components/molecules/action-button/action-button";
import { MTADeclined } from "@/config/app-constant";
import { PRODUCT } from "@/constants";
import { showMessenger } from "@/utils/cxone.utils";

type MTADeclinedSectionProps = {
  mtaDeclinedContent: {
    title: string;
    description: string;
    ctaButtonText: string;
  } | null;
};

function MTADeclinedSection({
  mtaDeclinedContent,
}: Readonly<MTADeclinedSectionProps>) {
  const router = useRouter();
  const { current } = useWizard();

  if (!mtaDeclinedContent) {
    return null;
  }
  const { title, description, ctaButtonText } = mtaDeclinedContent;

  const handleContinue = () => {
    router.push(current.next ?? "");
  };

  const handleWebChatClick = () => {
    showMessenger();
  };

  return (
    <div className="flex flex-col justify-start items-center md:pt-spacing-xl pt-spacing-m md:gap-spacing-xl gap-spacing-l relative md:min-h-[calc(100vh-188px)] min-h-[calc(100vh-96px)] px-spacing-m">
      <h1
        className={`text-center font-header-font md:text-5xl md:leading-[45px] text-[#fff] ${
          PRODUCT === "avanti" ? "lg:w-[690px] md:w-[558px]" : "md:w-[590px]"
        } w-[280px] text-xl leading-[30px]`}
      >
        {title}
      </h1>
      <div
        className={`${
          PRODUCT === "avanti" ? "lg:w-[588px] md:w-[558px]" : "md:w-[530px] "
        } w-[280px] p-spacing-m rounded-radius-lg border-solid border border-[#FFFFFF4D] bg-[#2724273D]`}
      >
        <RichText
          richText={description}
          className={`flex flex-col gap-spacing-s text-start font-body-font text-2xs leading-[24px] text-dark-text-body ${
            PRODUCT === "avanti" ? "[&>p>a]:text-surface-neutral-option-1" : ""
          }`}
          onClick={handleWebChatClick}
        />
      </div>
      <div className="!p-0 md:w-[342px] w-[280px] mx-auto">
        <ActionButton
          page={MTADeclined}
          showBackBtn={false}
          submitButtonClick={handleContinue}
          ctaButtonText={ctaButtonText}
        />
      </div>
    </div>
  );
}

export default MTADeclinedSection;
